import React from 'react';
import { Layout } from '../components/layout/Layout';
import { ComicHeading, ComicPanel } from '../components/ComicPanel';
import { Users, Palette, Heart } from 'lucide-react';

const About = () => {
  return (
    <Layout>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        {/* Hero */}
        <div className="text-center mb-16">
          <ComicHeading
            as="h1"
            className="text-4xl sm:text-5xl mb-6"
            data-testid="about-title"
          >
            About Pork Cops
          </ComicHeading>
          <p className="text-slate-300 text-lg">
          “Powered by Sporc. Backed by law.”
          </p>
        </div>

        {/* Story */}
        <ComicPanel className="p-8 mb-8">
          <h2 className="text-[#2FB4E9] uppercase font-bold tracking-widest text-xl mb-6">
            The Story
          </h2>

          <div className="relative border-2 border-slate-700 bg-slate-900/60 p-6 sm:p-8">
            <div className="absolute -top-3 left-4 border-2 border-black bg-[#00E5E5] px-3 py-1 text-xs font-black uppercase tracking-widest text-[#041014]">
              Case File
            </div>

            <div className="space-y-4 pt-4 text-slate-300 leading-relaxed">
              <p>
                When the residents of the Piggee Lands refuse to pay Beef Wellington for their
                town&apos;s source of free power, the Sporc is turned off by an invading Cowtallion.
              </p>

              <p>
                Hamee Hocks, the son of the town&apos;s Shereef, watches as his father and the
                safeguarding citizens fail at stopping the technologically advanced forces.
              </p>

              <p>
                For defying the Cowtallion, Hamee witnesses his friends and father being abruptly
                captured and taken away.
              </p>

              <p>
                Without the power they&apos;ve relied on for generations, the remaining inhabitants
                in the Piggee Lands are devastated.
              </p>

              <p>
                Hamee must journey into the unknown, free his piggee folk, save his father, and
                ultimately restore the Sporc.
              </p>

              <p className="text-lg font-bold text-[#00E5E5]">
                It&apos;s Ham against Beef in an epic conflict over Sporc Matters.
              </p>
            </div>
          </div>
        </ComicPanel>

        {/* Values */}
        <div className="grid sm:grid-cols-3 gap-6 mb-8">
          <ComicPanel className="p-6 text-center">
            <div
              className="w-12 h-12 mx-auto mb-4 flex items-center justify-center border-2 border-[#2FB4E9]"
              style={{ background: '#2FB4E9' }}
            >
              <Users className="w-6 h-6 text-white" />
            </div>
            <h3 className="text-white font-bold mb-2">Community First</h3>
            <p className="text-slate-400 text-sm">
              Built for fans, by fans. Your feedback shapes the story.
            </p>
          </ComicPanel>

          <ComicPanel className="p-6 text-center">
            <div
              className="w-12 h-12 mx-auto mb-4 flex items-center justify-center border-2 border-[#00FFFF]"
              style={{
                background: 'linear-gradient(90deg, #00FFFF 0%, #00E5E5 50%, #00BFCF 100%)',
              }}
            >
              <Palette className="w-6 h-6 text-[#041014]" />
            </div>
            <h3 className="text-white font-bold mb-2">Original Art</h3>
            <p className="text-slate-400 text-sm">
              Every panel hand-crafted with love and attention to detail.
            </p>
          </ComicPanel>

          <ComicPanel className="p-6 text-center">
            <div
              className="w-12 h-12 mx-auto mb-4 flex items-center justify-center border-2 border-[#FF6FAF]"
              style={{ background: '#FF6FAF' }}
            >
              <Heart className="w-6 h-6 text-white" />
            </div>
            <h3 className="text-white font-bold mb-2">Passion Project</h3>
            <p className="text-slate-400 text-sm">
              Made with heart, not algorithms. Stories that matter.
            </p>
          </ComicPanel>
        </div>

        {/* Team */}
        <ComicPanel className="p-8">
          <h2 className="text-[#2FB4E9] uppercase font-bold tracking-widest text-xl mb-4">
            The Team
          </h2>
          <p className="text-slate-300 leading-relaxed">
            Pork Cops is created by Melted Port Studios, a small team of artists and storytellers
            dedicated to bringing unique, engaging content to comic lovers everywhere. We believe
            in the power of independent comics and the communities that support them.
          </p>
        </ComicPanel>
      </div>
    </Layout>
  );
};

export default About;
